const GrammarTranslations: Record<string, Record<string, string>> = {
    german: {
      Nouns: "Nomen",
      Articles: "Artikel",
      Pronouns: "Pronomen",
      Adjectives: "Adjektive",
      Verbs: "Verben",
      Tenses: "Zeiten",
      Cases: "Fälle",
      Negation: "Verneinung",
      Prepositions: "Präpositionen",
      Conjunctions: "Konjunktionen",
      Imperatives: "Imperativ",
      SentenceStructure: "Satzstruktur",
    },
    english: {
      Nouns: "Nouns",
      Articles: "Articles",
      Pronouns: "Pronouns",
      Adjectives: "Adjectives",
      Verbs: "Verbs",
      Tenses: "Tenses",
      Cases: "Cases",
      Negation: "Negation",
      Prepositions: "Prepositions",
      Conjunctions: "Conjunctions",
      Imperatives: "Imperatives",
      SentenceStructure: "Sentence Structure",
    },
    tamil: {
      Nouns: "பெயர்ச்சொற்கள்",
      Articles: "நிச்சய/அநிச்சயக் கூறுகள்",
      Pronouns: "பிறர்சொற்கள்",
      Adjectives: "வணர்ச்சொற்கள்",
      Verbs: "வினைத்தொற்கள்",
      Tenses: "காலங்கள்",
      Cases: "வேற்பாடுகள்",
      Negation: "எதிர்மறை",
      Prepositions: "முன் இணைச் சொற்கள்",
      Conjunctions: "இணைச்சொற்கள்",
      Imperatives: "ஆணை வாக்கியம்",
      SentenceStructure: "வாக்கிய அமைப்பு",
    },
    sinhala: {
      Nouns: "නාම පද",
      Articles: "නිශ්චිත/අනිශ්චිත",
      Pronouns: "සාදරණ පද",
      Adjectives: "විශේෂණ",
      Verbs: "ක්‍රියා පද",
      Tenses: "කාල",
      Cases: "විභක්ති",
      Negation: "ඇමුණුම්",
      Prepositions: "පූර්ව පද",
      Conjunctions: "සන්ධි පද",
      Imperatives: "ඇණවුම් වාක්‍ය",
      SentenceStructure: "වාක්‍ය ව්‍යුහය",
    },
    hindi: {
      Nouns: "संज्ञा",
      Articles: "लेख",
      Pronouns: "सर्वनाम",
      Adjectives: "विशेषण",
      Verbs: "क्रियाएँ",
      Tenses: "काल",
      Cases: "विभक्ति",
      Negation: "नकार",
      Prepositions: "पूर्वसर्ग",
      Conjunctions: "संयोजन",
      Imperatives: "आज्ञार्थक",
      SentenceStructure: "वाक्य संरचना",
    },
    arabic: {
      Nouns: "الأسماء",
      Articles: "أدوات التعريف",
      Pronouns: "الضمائر",
      Adjectives: "الصفات",
      Verbs: "الأفعال",
      Tenses: "الأزمنة",
      Cases: "الحالات",
      Negation: "النفي",
      Prepositions: "حروف الجر",
      Conjunctions: "أدوات الربط",
      Imperatives: "الأمر",
      SentenceStructure: "بنية الجملة",
    },
    turkish: {
      Nouns: "İsimler",
      Articles: "Artikeller",
      Pronouns: "Zamirler",
      Adjectives: "Sıfatlar",
      Verbs: "Fiiller",
      Tenses: "Zamanlar",
      Cases: "Hâller",
      Negation: "Olumsuzluk",
      Prepositions: "Edatlar",
      Conjunctions: "Bağlaçlar",
      Imperatives: "Emir",
      SentenceStructure: "Cümle Yapısı",
    },
    russian: {
      Nouns: "Существительные",
      Articles: "Артикли",
      Pronouns: "Местоимения",
      Adjectives: "Прилагательные",
      Verbs: "Глаголы",
      Tenses: "Времена",
      Cases: "Падежи",
      Negation: "Отрицание",
      Prepositions: "Предлоги",
      Conjunctions: "Союзы",
      Imperatives: "Повелительное наклонение",
      SentenceStructure: "Структура предложения",
    },
    chinese: {
      Nouns: "名词",
      Articles: "冠词",
      Pronouns: "代词",
      Adjectives: "形容词",
      Verbs: "动词",
      Tenses: "时态",
      Cases: "格",
      Negation: "否定",
      Prepositions: "介词",
      Conjunctions: "连词",
      Imperatives: "命令式",
      SentenceStructure: "句子结构",
    },
    french: {
      Nouns: "Noms",
      Articles: "Articles",
      Pronouns: "Pronoms",
      Adjectives: "Adjectifs",
      Verbs: "Verbes",
      Tenses: "Temps",
      Cases: "Cas",
      Negation: "Négation",
      Prepositions: "Prépositions",
      Conjunctions: "Conjonctions",
      Imperatives: "Impératifs",
      SentenceStructure: "Structure de phrase",
    },
    spanish: {
      Nouns: "Sustantivos",
      Articles: "Artículos",
      Pronouns: "Pronombres",
      Adjectives: "Adjetivos",
      Verbs: "Verbos",
      Tenses: "Tiempos",
      Cases: "Casos",
      Negation: "Negación",
      Prepositions: "Preposiciones",
      Conjunctions: "Conjunciones",
      Imperatives: "Imperativos",
      SentenceStructure: "Estructura de la oración",
    },
  };
  
  export default GrammarTranslations;
  